import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { LineageData } from '@/shared/types/lineage';

/**
 * OpenMetadata API 응답 타입
 * 실제 API는 이미 Record 형태로 nodes와 edges를 반환함
 */
export type LineageResponse = LineageData;

export const fetchLineage = async (entityType: string, fqn: string): Promise<LineageResponse> => {
  const response = await openMetadataApiClient.get<LineageResponse>(`/lineage/getLineage`, {
    params: {
      fqn,
      type: entityType,
      upstreamDepth: 1,
      downstreamDepth: 2,
      query_filter: '',
      includeDeleted: false,
      size: 50,
    },
  });

  return response.data;
};
